// import Firma from '@/components/Firma.vue';
import mixAvanceProgramado from '@/helpers/calculos/mixAvanceProgramado';
import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  name: 'MainEstimacionesReportePenasConvencionales',
  components: {
  },
  mixins: [mixAvanceProgramado, mixGenerarPdf, mixFormatoEstructura],
  /*
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    estimaciones: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
  },
  */
  data() {
    return {
      tipo: 'baseDias',
      importeProgramadoEstaEstimacion: 0,
      importeEjecutadoEstaEstimacion: 0,
      importeAtrasoEstaEstimacion: 0,
      importeRetenidoAnteriormente: 0,
      importeRetencionAplicarEstaEstimacion: 0,
      importeDevolucionEstaEstimacion: 0,
      porcentajeSancion: 1,
    };
  },
  mounted() {
    this.calcular();
  },
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdfPenasConvencionales() {
    // async generarPdf() {
      this.$emit('generando');
      const contratoConFormato = this.formatoObjeto(this.contrato);
      const estimacionConFormato = this.formatoObjeto(this.estimacion);
      const supervisor = this.getSupervisor || '';
      // const firmasFuncionarios = this.firmas;
      const datosCalculados = {
        tipo: this.contrato.tipoRetencion,
        diasTranscuridos: this.getPrograma.diasTranscuridos,
        importeDelContrato: this.importeDelContrato,
        importeProgramadoEstaEstimacion: this.importeProgramadoEstaEstimacion,
        importeEjecutadoEstaEstimacion: this.importeEjecutadoEstaEstimacion,
        montoDiarioProgramado: this.montoDiarioProgramado,
        diasEjecutadosReales: this.diasEjecutadosReales,
        diasDeDesfazamiento: this.diasDeDesfazamiento,
        montoDeAtraso: this.montoDeAtraso,
        porcentajeRetencion: (this.porcentajeRetencion * 100),
        importeRetencionEstaEstimacion: this.importeRetencionEstaEstimacion,
        importeRetenidoAnteriormente: this.importeRetenidoAnteriormente,
        montoFueraPrograma: this.montoFueraPrograma,
        diasDeAtraso: this.diasDeAtraso,
        porcentajeSancion: this.porcentajeSancion,
        sancionAplicarEstaEStimacion: this.sancionAplicarEstaEStimacion,
        sumaSancionesAnteriores: this.sumaSancionesAnteriores,
        importeAtrasoEstaEstimacion: this.importeAtrasoEstaEstimacion,
        seccionRetencionSancion: this.seccionRetencionSancion,
      };
      const datos = this.formatoObjeto(datosCalculados);
      const cliente = this.getCliente || { logo: '', nombre: '' };

      const nombreTemplate = 'templatePenasConvencionales';
      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          contrato: contratoConFormato,
          estimacion: estimacionConFormato,
          supervisor,
          firmas: '',
          datos,
          cliente,
          footer: '',
        },
      }, `${this.contrato.numero}_PenasConvencionales_Estimacion_${this.estimacion.numero}`);
      this.$emit('terminando');
    },

    calcular() {
      this.importeProgramadoEstaEstimacion = this.estimacion.importeMontoProgramado;
      this.importeEjecutadoEstaEstimacion = this.acumuladoTotal;
      this.importeAtrasoEstaEstimacion = this.importeProgramadoEstaEstimacion
        - this.importeEjecutadoEstaEstimacion;
      this.importeRetenidoAnteriormente = this.importeTotalRetenidoAnteriormente;
    },
  },
  computed: {
    importeRetencionEstaEstimacion() {
      const esRetencionPorDia = this.contrato.esRetencionPorDia || false;

      if (!esRetencionPorDia) {
        return (this.montoDeAtraso * (this.porcentajeRetencion));
      }
      return (this.montoDeAtraso * (this.porcentajeRetencion)) * this.diasDeDesfazamiento;
    },
    getTipoRetencionContrato() {
      return this.contrato.tipoRetencion || null;
    },
    importeDelContrato() {
      return this.estimacion.importeContratoSinFinanciamiento;
    },
    numeroEstimacion() {
      return Number(this.estimacion.numero);
    },
    porcentajeRetencion() {
      if (!this.contrato) return 0.005;
      if (!this.contrato.porcentajeRetencion) return 0.005;

      return (this.contrato.porcentajeRetencion / 100);
    },
    getPrograma() {
      return this.mixCalcularPrograma(this.estimacion.fechaAl);
    },
    montoDiarioProgramado() {
      const { diasTranscuridos } = this.getPrograma;
      return (this.estimacion.importeMontoProgramado / diasTranscuridos);
    },
    diasEjecutadosReales() {
      const redondearHaciaArriba = this.contrato.redondearMasDiasEjecutados || false;
      if (redondearHaciaArriba) {
        return Math.ceil((this.importeEjecutadoEstaEstimacion / this.montoDiarioProgramado));
      }
      return Math.floor((this.importeEjecutadoEstaEstimacion / this.montoDiarioProgramado));
    },
    diasDeDesfazamiento() {
      const { diasTranscuridos } = this.getPrograma;
      const diasDesfasamiento = (diasTranscuridos - this.diasEjecutadosReales);
      if (diasDesfasamiento < 0) return 0;
      return diasDesfasamiento;
    },
    montoDeAtraso() {
      let monto = 0;
      if (this.getTipoRetencionContrato && this.getTipoRetencionContrato === 'baseMonto') {
        monto = (this.importeProgramadoEstaEstimacion - this.importeEjecutadoEstaEstimacion);
      } else {
        monto = (this.diasDeDesfazamiento * this.$numberRound(this.montoDiarioProgramado));
      }

      if (monto < 0) return 0;
      return monto;
    },
    contratoTotalAnticipo() {
      return this.$ObjSumar(this.contrato.anticipos, 'importe');
    },
    estimacionesAnteriores() {
      return this.estimaciones.filter(
        ({ numero }) => Number(numero) < this.numeroEstimacion,
      );
    },
    amortizacionAnticipoAcumuladoAnteriror() {
      return this.$ObjSumar(
        this.estimacionesAnteriores,
        'importeAmortizacionAnticipo',
      );
    },
    amortizacionAnticipoAcumuladoTotal() {
      return (
        this.amortizacionAnticipoAcumuladoAnteriror
        + this.estimacion.importeAmortizacionAnticipo
      );
    },
    amortizacionAnticipoSaldo() {
      return (
        this.contratoTotalAnticipo - this.amortizacionAnticipoAcumuladoTotal
      );
    },
    estimadoAcumuladoAnteriror() {
      return this.$ObjSumar(this.estimacionesAnteriores, 'importeEstimado');
    },
    acumuladoTotal() {
      if (!this.estimacion.importeEstimado) return 0;
      /*
      console.log('acumuladoTotal... ',
        this.estimacion.importeEstimado, '-->', this.estimadoAcumuladoAnteriror,
        this.estimacion.importeEstimado + this.estimadoAcumuladoAnteriror);
      */
      return this.estimacion.importeEstimado + this.estimadoAcumuladoAnteriror;
    },
    importeTotalRetenidoAnteriormente() {
      const retenidoAnterior = this.$ObjSumar(this.estimacionesAnteriores, 'importeRetenido');
      const retenidoDevuelto = this.$ObjSumar(this.estimacionesAnteriores, 'importeDevuelto');
      return (retenidoAnterior - retenidoDevuelto);
    },
    importeRetencionNetaAplica() {
      const importe = this.importeRetencionEstaEstimacion - this.importeTotalRetenidoAnteriormente;
      if (importe <= 0) return 0;
      return importe;
    },
    ordenarListadoFirmas() {
      if (!this.firmas) return [];
      return this.firmas.slice().sort((a, b) => a.orden - b.orden);
    },
    estimacionesDentroPrograma() {
      const estimacionFinPrograma = this.estimaciones
        .find(({ esEstimacionFinPrograma }) => esEstimacionFinPrograma === true);

      if (!estimacionFinPrograma) return [];

      return this.estimaciones
        .filter(
          ({ numero }) => Number(numero) <= Number(estimacionFinPrograma.numero),
        );
    },
    montoFueraPrograma() {
      const montoAnterior = this.$ObjSumar(this.estimacionesDentroPrograma, 'importeEstimado');

      if (this.estimacion.esEstimacionFiniquito) {
        return (this.importeEjecutadoEstaEstimacion - montoAnterior);
      }
      return (this.importeDelContrato - montoAnterior);
    },
    diasDeAtraso() {
      const { fechaTermino: fechaTerminoPrograma } = this
        .mixGetPrograma[this.mixGetPrograma.length - 1];
      const fechaTerminoEstimacion = this.estimacion.fechaAl;
      return this.calcularDiferenciaEnDias(fechaTerminoPrograma, fechaTerminoEstimacion) - 1;
    },
    sumaSancionesAnteriores() {
      return this.$ObjSumar(this.estimacionesAnteriores, 'importeSancion');
    },
    sancionAplicarEstaEStimacion() {
      const importeDeAtraso = this.montoFueraPrograma * this.diasDeAtraso;
      return importeDeAtraso * (this.porcentajeSancion / 100);
    },
    getSupervisor() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    seccionRetencionSancion() {
      const estimacionFinPrograma = this.estimaciones
        .find(({ esEstimacionFinPrograma }) => esEstimacionFinPrograma === true);
      if (!this.estimacion.numero) return '';
      if (!estimacionFinPrograma || estimacionFinPrograma.numero >= this.estimacion.numero) { return 'retencion'; }
      return 'sancion';
    },
    getCliente() {
      if (!this.contrato.cliente) return { logo: '', nombre: '' };
      return this.contrato.cliente;
    },
  },
  watch: {
    estimacion: {
      handler() {
        // this.calcular();
      },
    },
  },
};
